import { Box, SelectMultiLanguage, Typography } from "@maysoft/common-component-react";

import Helpers from "../../commons/helpers";
import { typography } from "./styles";


interface IProps {
    title: string;
    description: string;
    defaultLanguage?: string;
    children?: React.ReactNode;
    setLanguage?: React.Dispatch<React.SetStateAction<string>>;
}

const Header: React.FC<IProps> = ({ title, description, defaultLanguage, children, setLanguage }) => {
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
            <Box>
                <Box display="flex" alignItems="center" justifyContent="center" gap={1}>
                    <Typography variant="h5">{title}</Typography>
                    {children}
                </Box>
                <Typography sx={typography}>{description}</Typography>
            </Box>
            {defaultLanguage && Helpers.isFunction(setLanguage) && (
                <SelectMultiLanguage defaultLanguage={defaultLanguage} onChangeLanguage={setLanguage} />
            )}
        </Box>
    );
};

export default Header;
